import type { FieldMetadata } from 'models/forms/fields/FieldMetadata';
import type { IntlShape } from 'react-intl';
import { CSV_SEPARATOR, downloadCsv } from 'utils/documents/downloadDocument';

import type { GridData } from './GridField.model';

export function exportCSV(
  id: string,
  headers: ReadonlyArray<FieldMetadata>,
  data: Readonly<GridData>,
  isRowIndexDisplayed: boolean,
  { formatMessage, locale }: IntlShape,
) {
  const withIndexHeaders = isRowIndexDisplayed
    ? [
        {
          id: `${id}.periodNumber`,
        },
        ...headers,
      ]
    : headers;
  const csvHeaders: string = withIndexHeaders
    .map(header => `"${formatMessage({ id: `form.${header.id}` as any, defaultMessage: header.id })}"`)
    .join(CSV_SEPARATOR);

  const csvRows = data.map((line, rowIndex) => {
    const csvRow = headers.map(header => `"${getCellValueByFieldType(header, line[header.id])}"`);
    return (isRowIndexDisplayed ? [rowIndex + 1, ...csvRow] : csvRow).join(CSV_SEPARATOR);
  });

  const csvData = [csvHeaders, ...csvRows].join('\n');
  downloadCsv(csvData, id, locale);
}

function getCellValueByFieldType(cellMetadata: FieldMetadata, cellValue: unknown) {
  switch (cellMetadata.type) {
    case 'PercentField':
      return Number.isFinite(cellValue) ? `${cellValue} ${cellMetadata.unit}` : '';
    case 'NumberField':
    case 'AmountField':
      return Number.isFinite(cellValue) ? cellValue : '';
    default:
      return cellValue ?? '';
  }
}
